import axios from 'axios';
import logComponent from '../logComponent';
import getConfig from './getConfig';

const CheckIn = (function() {
  function GetByMonitoredIndividual(monitoredIndividualId, pastNumberOfDays) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetByMonitoredIndividual'); }
    let params = { monitoredIndividualId, pastNumberOfDays };

    return axios.get('api/CheckIn/GetByMonitoredIndividual', getConfig( params));    
  }

  function GetByUnit(unitId, pastNumberOfDays) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetByUnit'); }
    let params = { unitId, pastNumberOfDays };

    return axios.get('api/CheckIn/GetByUnit', getConfig( params));      
  }

  function GetLatestByMonitoredIndividual(monitoredIndividualId) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetLatestByMonitoredIndividual'); }
    const params = { monitoredIndividualId };

    return axios.get('api/CheckIn/GetLatestByMonitoredIndividual', getConfig( params));
  }

  function GetLatestByUnit(unitId) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetLatestByUnit'); }
    const params = { unitId };

    return axios.get('api/CheckIn/GetLatestByUnit', getConfig( params));
  }

  function GetMoodAverages(pastNumberOfDays) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetMoodAverages'); }
    const params = { pastNumberOfDays };
    let configWithParams = getConfig(params);


    return axios.get('api/CheckIn/GetMoodAverages', configWithParams);
  }

  function GetMoodAveragesForMonitoredIndividual(monitoredIndividualId, pastNumberOfDays) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetMoodAveragesForMonitoredIndividual'); }
    const params = { monitoredIndividualId, pastNumberOfDays };

    return axios.get('api/CheckIn/GetMoodAveragesForMonitoredIndividual', getConfig( params));
  }

  function GetMoodAveragesForUnit(unitId, pastNumberOfDays) {
    if (logComponent('CheckIn')) { console.debug('CheckIn GetMoodAveragesForUnit'); }
    const params = { unitId, pastNumberOfDays };

    return axios.get('api/CheckIn/GetMoodAveragesForUnit', getConfig( params));
  }

  function Save(staffCheckHistory) {
    if (logComponent('CheckIn')) { console.debug('CheckIn Save'); }
    return axios.post('api/CheckIn/Save', staffCheckHistory, getConfig());
  }

  function SaveCancelled(cancelledStaffCheckHistory) {
    if (logComponent('CheckIn')) { console.debug('CheckIn SaveCancelled'); }
    return axios.post('api/CheckIn/SaveCancelled', cancelledStaffCheckHistory, getConfig());
  }

  return {
    GetByMonitoredIndividual,
    GetByUnit,
    GetLatestByMonitoredIndividual,
    GetMoodAveragesForUnit,
    GetLatestByUnit,
    GetMoodAverages,
    GetMoodAveragesForMonitoredIndividual,
    Save,
    SaveCancelled
  }
})();

export default CheckIn;